import { uploadData } from 'aws-amplify/storage'

export const uploadFileS3 = (fileData) => {
  const { PATH, fileName, file } = fileData
  return async (dispatch) => {
    try {
      const imageUploadRes = await uploadData({
        key: PATH + fileName,
        data: file,
        options: { contentType: file.type }
      }).result
      return imageUploadRes
    } catch (e) {
      throw e
    }
  }
}
